import { Box, Flex, Link as ThemeLink, Text, Image } from '@theme-ui/components';
import { Logo } from '~/Common'
import { Link } from 'react-router-dom';
import {
    KeyboardNavigation,
} from '~/Common';
import { useResponsiveValue } from '@theme-ui/match-media';

export const Layout = ({ children, sx, banner = "/img/sidebar-banner.png", whitelabelLogo = '', ...props }) => {
    const isMobile = useResponsiveValue([true, true, false]);

    return (
        <>
            <KeyboardNavigation>
                <ThemeLink href="#content">Skip to content</ThemeLink>
            </KeyboardNavigation>

            <Flex sx={{ flexDirection: 'row', minHeight: [0, 0, '100vh'] }}>
                <Box sx={{
                    width: [0, 0, '40%'],
                    backgroundSize: 'cover',
                    backgroundPosition: 'left center',
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                }}
                >
                    <Image src={banner ? banner : "/img/sidebar-banner.png"} sx={{
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom:0,
                        zIndex: '-2',
                        height: '100%',
                        objectFit: 'cover',
                    }} />
                    <Box as={Link} to="/" sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                        {whitelabelLogo ? 
                            (
                                <Image px="40px" py="64px" src={whitelabelLogo} />
                            ) : (
                                <Logo p={5} px="40px" width="180" color="white" />
                            )}
                    </Box>

                    <Box p={5} px="40px" mt={'auto'}>
                        <Text as="p" sx={{
                          fontSize: '43px',
                          letterSpacing: '-0.02em',
                          lineHeight: 1
                        }} color="white">{props.sellStatement ? props.sellStatement : `Invest in world\nchanging ideas.`}</Text>
                    </Box>
                </Box>

                <Flex sx={{
                    width: ['100%', '100%', '60%'],
                    backgroundColor: 'white',
                    justifyContent: 'center',
                    alignContent: 'flex-start',
                    overflowY: 'auto',
                }}>
                    <Box sx={{
                        maxHeight: '100vh',
                        position: 'relative'
                    }}>
                        <Box
                            sx={{
                                py: 5,
                                px: [2,5],
                                width: '568px',
                                maxWidth: '100%',
                                ...sx
                            }}
                            {...props}
                            id="content"
                        >
                            {isMobile && (
                                <Box sx={{ width: '100%', textAlign: 'center' }}>
                                    {whitelabelLogo ? (
                                        <Box sx={{ mx: 'auto', width: '100%' }}>
                                            <Image  pb={2} mb={4} style={{filter: 'invert(1)'}} src={whitelabelLogo} />
                                        </Box>
                                    ) : (
                                        <Box as={Link} to="/" px={3} sx={{ mx: 'auto' }}>
                                            <Logo width="180" color="black" center={true} mb={4} />
                                        </Box>
                                    )}
                                </Box>
                            )}
                            {children}
                        </Box>
                    </Box>
                </Flex>
            </Flex>
        </>
    );
};
